export class Adjustment {
  id: number;
  actionDate: string;
  actionBy: string;
  amount: number;
  contributionWithheld: boolean;
  createdBy: string;
  creatorId: number;
  fileName: string;
  isApproved: boolean;
  isArchived: boolean;
  isDeletable: boolean;
  submittedDate: string;
}

export class AdjustmentFileData {
  userInfo: any;
  adjustmentEntryId: number;
}

export class EditAdjRecords {
  fiscalYear: number;
  fullSSN: string;
  employementInfo: [];
  fiscalYearScheduleList: [];
}

export class AdjustmentRecord {
  id: number;
  adjustmentImportId: number;
  ssn: string;
  fullSSN: string;
  fiscalYear: number;
  lastFourSSN: string;
  firstName: string;
  middleInitials: string;
  lastName: string;
  locationCode: string;
  systemCode: string;
  payrollSchedule: string;
  payPeriodBeginningDate: Date;
  payPeriodEndDate: Date;
  actualAnnualCompensation: number;
  actualEarnableCompensation: number;
  payPeriodBaseSalary: number;
  employeeContribution: number;
  hoursWorked: number;
  standardHours: number;
  percentFullTime: number;
  employementInfo: [];
  fiscalYearScheduleList: [];
  isInvalid: boolean;
}

export class SaveAdjustmentPayload {
  id: number;
  payrollAdjustmentsId: number;
  ssn: string;
  firstName: string;
  lastName: string;
  middleInitials: string;
  systemCode: string;
  locationCode: string;
  payScheduleId: number;
  reasonCodes: string;
  ppedstart: Date;
  ppedend: Date;
  actualAnnualCompensation: number;
  employeeContribution: number;
  hoursWorked: number;
  standardHours: number;
  percentFullTime: number;
  payPeriodBaseSalary: number;
  actualEarnableCompensation: number;
  payPeriodStartDate: Date;
  payPeriodEndDate: Date;
  payPeriodBeginningDate: Date;
  review: boolean;
}
